/* eslint-disable max-statements */
import axios from 'axios';
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import validator from 'validator';
import { LoginAuthAction } from '../redux/actions/authAction';
import FacebookLoginComponent from '../components/facebookLogin';
import { globalEnv } from '../config/baseConfig';

export default function Login() {
	const [showPassword, setshowPassword] = useState(false);
	const [inputEmail, setinputEmail] = useState('');
	const [inputEmailTouched, setinputEmailTouched] = useState(false);
	const [inputPassword, setinputPassword] = useState('');
	const [inputPasswordTouched, setinputPasswordTouched] = useState(false);

	const stateAuth = useSelector((state: any) => state.auth);

	const dispatch = useDispatch();

	const [emailErrorMsg, setemailErrorMsg] = useState({
		message: '',
		error: false
	});
	const [passwordErrorMsg, setpasswordErrorMsg] = useState({
		message: '',
		error: false
	});
	const loginReq = async () => {
		const body = {
			email: inputEmail,
			password: inputPassword,
			deviceId: '000000'
		};
		return await axios
			.post(globalEnv.BASE_URL + '/admin/user/login', body)
			.catch(function (error) {
				if (error.response.data.message == 'Wrong password.') {
					setpasswordErrorMsg({ message: 'Wrong password.', error: true });
				} else
					setemailErrorMsg({
						message: 'No admin account with such email exists',
						error: true
					});
				throw new Error(error.response);
			});
	};

	const navigate = useNavigate();

	const loginSubmit = useMutation(loginReq, {
		onSuccess: (res) => {
			dispatch(LoginAuthAction(res.data));
			navigate(`../home/documents`);
		}
	});

	const verifEmailFormat = (email = '') => {
		if (validator.isEmpty(email, { ignore_whitespace: true })) {
			setemailErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
		} else {
			if (!validator.isEmail(email)) {
				setemailErrorMsg({
					error: true,
					message: 'Email must be a valid format'
				});
			} else if (email.indexOf(' ') >= 0) {
				setemailErrorMsg({
					error: true,
					message: 'Email must not contain white spaces'
				});
			} else {
				setemailErrorMsg({ error: false, message: '' });
			}
		}
	};

	const verifPasswordFormat = (password = '') => {
		if (validator.isEmpty(password, { ignore_whitespace: true })) {
			setpasswordErrorMsg({ error: true, message: 'Please enter a password' });
		} else {
			if (password.length < 5) {
				setpasswordErrorMsg({
					error: true,
					message: 'Please enter a password longer than 5 characters'
				});
			} else if (password.length > 32) {
				setpasswordErrorMsg({
					error: true,
					message: 'Please enter a password shorter than 32 characters'
				});
			} else {
				setpasswordErrorMsg({ error: false, message: '' });
			}
		}
	};

	return (
		<div>
			<div
				className="absolute w-full h-full"
				style={{
					filter: 'blur(6px)',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundImage: `url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80')`
				}}
			/>
			<div className="absolute w-full h-screen bg-black opacity-50" />

			<figure className="absolute h-screen flex z-50 top-0 left-0 right-0">
				<div className="w-full max-w-md m-auto bg-gray-900 rounded-xl border border-gray-600 shadow-default pt-10 pb-5 px-1">
					<blockquote className="text-2xl font-medium text-center">
						<p className="text-lg font-semibold">Meavana admin panel</p>
					</blockquote>

					<div className="text-primary m-6">
						<div className="flex items-center mt-3 justify-center">
							<h1 className="text-2xl font-medium text-primary mt-4 mb-2">
								Login to your account
							</h1>
						</div>
						<form
							onSubmit={(e) => {
								e.preventDefault();
								if (
									!loginSubmit.isLoading &&
									inputEmailTouched &&
									inputPasswordTouched
								)
									loginSubmit.mutate();
							}}
						>
							<label className="text-left">Email</label>
							<input
								name="email"
								type="text"
								value={inputEmail}
								// onChange={handleChange}
								placeholder="Email"
								className="h-12 w-full border mt-2 rounded-lg outline-none p-2 placeholder-gray-500 text-black font-semibold"
								onBlur={() => {
									verifEmailFormat(inputEmail);
								}}
								onFocus={() => {
									setemailErrorMsg({ error: false, message: '' });
								}}
								onChange={(event) => {
									setinputEmail(event.target.value);
									setinputEmailTouched(true);
								}}
							/>
							{emailErrorMsg.error ? (
								<p className="text-red-500 text-xs italic text-right ml-auto h-4">
									{emailErrorMsg.message}
								</p>
							) : (
								<div className="mb-4" />
							)}

							<label className="mt-5">Password</label>

							<div className="container-input-icon-auth">
								<div className="relative">
									<input
										className="h-12 w-full border mt-2 rounded-lg outline-none p-2 placeholder-gray-500 text-black  font-semibold"
										type={showPassword ? 'text' : 'password'}
										placeholder="Password"
										onBlur={() => {
											verifPasswordFormat(inputPassword);
										}}
										onFocus={() => {
											setpasswordErrorMsg({ error: false, message: '' });
										}}
										onChange={(event) => {
											setinputPassword(event.target.value);
											setinputPasswordTouched(true);
										}}
									/>{' '}
									{showPassword ? (
										<FaEye
											className=" absolute top-6 right-3 cursor-pointer"
											onClick={() => {
												setshowPassword(false);
											}}
										/>
									) : (
										<FaEyeSlash
											className=" absolute top-6 right-3 cursor-pointer"
											onClick={() => {
												setshowPassword(true);
											}}
										/>
									)}
									{passwordErrorMsg.error ? (
										<p className="text-red-500 text-xs italic text-right ml-auto h-4">
											{passwordErrorMsg.message}
										</p>
									) : (
										<div className="mb-7" />
									)}
								</div>
							</div>
							{stateAuth.error ? (
								<div className="bg-indigo-900 text-center py-4 lg:px-4">
									<div
										className="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
										role="alert"
									>
										<span className="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">
											Error
										</span>
										<span className="font-semibold mr-2 text-left flex-auto">
											{stateAuth.error.message}
										</span>
										<svg
											className="fill-current opacity-75 h-4 w-4"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
										>
											<path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
										</svg>
									</div>
								</div>
							) : null}
							<div className="flex items-center flex-col mt-3 justify-center">
								<button
									type="submit"
									className={`btn btn-sm btn-primary mt-2 ${
										loginSubmit.isLoading ? 'loading' : ''
									}`}
									value="Login"
									disabled={
										loginSubmit.isLoading ||
										!inputEmailTouched ||
										!inputPasswordTouched
									}
								>
									{loginSubmit.isLoading ? 'Logging in...' : 'Login'}
								</button>

								<div className="mt-5">
									<FacebookLoginComponent />
								</div>
							</div>
						</form>
					</div>
				</div>
			</figure>
		</div>
	);
}
